import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from "@mui/material/Stack";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    width: 400,
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

interface CreateApplicationModalProps {
    show: boolean;
    handleClose(): void;
    reFetch(): void;
}

const CreateApplicationModal = (props: CreateApplicationModalProps): React.ReactElement => {
    const [name, setName] = React.useState<string>("");

    const createApp = async(): Promise<void> => {
        const result = await fetch(`/api/v1/Application`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("echo-si-jwt")}`
            },
            body: JSON.stringify(name)
        });

        if(result.status == 200) {
            setName("");
            props.handleClose();
            props.reFetch();
            return;
        }
        else return;
    };

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={props.show}
                onClose={props.handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={props.show}>
                    <Box sx={style}>
                        <Stack
                            onSubmit={(e: any) => {
                                e.preventDefault();
                                createApp().then();
                                return false;
                            }}
                            component="form"
                            noValidate
                            autoComplete="off"
                            spacing={3}
                        >
                            <TextField id="outlined-basic" required value={name} onChange={e => setName(e.currentTarget.value)} label="Name" variant="outlined" />
                            <Button variant="contained" type="submit">Confirm creation</Button>
                        </Stack>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
};

export default CreateApplicationModal;